import React from 'react';
import { Col, Row } from 'antd';
import { StyledHero } from '../styles';
import Button from '../../Button/index';
import WebsiteImage from '../../WebsiteImage';

const Hero = ({ heroImg, wrench }) => {
  return (
    <>
      <StyledHero heroImg={heroImg}>
        <Row type="flex" justify="center">
          <WebsiteImage className="wrench-image" src={wrench} />
          <Col sm={{ span: 22, offset: 0 }} lg={{ span: 18, offset: 6 }}>
            <h1>
              ServiceTitan’s <br />
              Contractor Playbook
            </h1>
            <p>
              Life in the trades is a journey. From starting before sunrise to middle-of-the-night
              calls, and from one person in a truck growing into a thriving operation — there’s no
              end to the challenges, and no end to the rewards of a job well done. Through storms
              and pandemics, contractors deliver for their customers, each and every day.
            </p>
            <p>
              At ServiceTitan, our goal is to help contractors succeed — because your success is our
              success.{' '}
            </p>
            <p>
              This Contractors Playbook is just one step along the way — sharing best practices from
              our team, as well as some of the top leaders in our industry. We’ve created it to take
              you from creating a company and a culture to making an impact with marketing, and from
              answering the phone to closing the books on another successful month.
            </p>
            <p>
              The Playbook will continue to evolve, because our journey — just like yours — never
              ends.
            </p>
            <Button
              type="secondary"
              dataPosition="contractor playbook hero"
              to="#playbook-content"
              className="playbook-hero-btn"
            >
              Get Started
            </Button>
          </Col>
        </Row>
      </StyledHero>
    </>
  );
};

export default Hero;
